import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/google-pay.svg")